import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilitariosDataService {

  public applicationJsonHeaders = new HttpHeaders({
    'Content-Type':  'application/json'
  })

  constructor(private httpClient: HttpClient) { }

  cep(request: any, token: string) {
    return this.httpClient.get<any>(
      `https://viacep.com.br/ws/${request}/json/`,
      {
        observe: 'response',
        headers: new HttpHeaders({
          'Content-Type':  'application/json'
        })
      }
    );
  }
}
